import { z } from 'zod';

import { cursor } from '@nesso/common-contracts/cursor';
import { defineQuery } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

export const GET_PRACTICE_MEMBER_USAGE_TYPE = 'reporting/get-practice-member-usage';

export const getPracticeMemberUsage = defineQuery(
    GET_PRACTICE_MEMBER_USAGE_TYPE,
    cursor.input.extend({
        search: z
            .string()
            .transform((x) => x.trim())
            .optional(),
        // `z.string().pipe(...)` so a raw query string satisfies `z.input` while the reader sees the union.
        sortBy: z
            .string()
            .pipe(
                z.enum([
                    'name',
                    'lastLoginAt',
                    'lastSessionAt',
                    'allNotes',
                    'last30Days',
                    'last7Days',
                ]),
            )
            .default('name'),
        sortDirection: z
            .string()
            .pipe(z.enum(['asc', 'desc']))
            .default('asc'),
        // Snapshot time echoed from page 1's output; absent on the first page.
        asOf: z.iso.datetime().meta(metadata.nonSensitive).optional(),
    }),
    cursor.output.extend({
        // Whole matching set, composed into the first page only — null whenever a cursor is sent.
        summary: z
            .object({
                practiceMemberCount: z.number().int().nonnegative().meta(metadata.nonSensitive),
                allNotes: z.number().int().nonnegative().meta(metadata.nonSensitive),
                last30Days: z.number().int().nonnegative().meta(metadata.nonSensitive),
                last7Days: z.number().int().nonnegative().meta(metadata.nonSensitive),
            })
            .nullable(),
        // The instant every count and window in this page was computed at; send it back with `cursor`.
        asOf: z.iso.datetime().meta(metadata.nonSensitive),
        practiceMembers: z.array(
            z.object({
                practiceMemberId: z.uuid().meta(metadata.nonSensitive),
                name: z.string(),
                email: z.email(),
                lastLoginAt: z.iso.datetime().nullable().meta(metadata.nonSensitive),
                lastSessionAt: z.iso.datetime().nullable().meta(metadata.nonSensitive),
                allNotes: z.number().int().nonnegative().meta(metadata.nonSensitive),
                last30Days: z.number().int().nonnegative().meta(metadata.nonSensitive),
                last7Days: z.number().int().nonnegative().meta(metadata.nonSensitive),
            }),
        ),
    }),
);
